export default __webpack_public_path__ + "b7671d6f29d6e38c3968fa9ed7d607d9.png";